var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"consult-channel-sort-bar"},[(_vm.activityData)?_c('div',{class:[
      'sort-item',
      'activity-tag',
      { active: +_vm.value.anniversary && _vm.selected }
    ],on:{"click":_vm.handleClickActiveTag}},[_c('img',{attrs:{"src":+_vm.value.anniversary ? _vm.activityData.active : _vm.activityData.img}})]):_vm._e(),_vm._l((_vm.list),function(item,index){return _c('div',{key:index,class:[
      'sort-item',
      { active: _vm.value[item.type] == item.value && _vm.selected }
    ],on:{"click":function($event){return _vm.change(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),(_vm.mask)?_c('div',{staticClass:"mask"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }